import React from 'react'
import { useParams } from 'react-router-dom'
import { withUserStore } from '../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from './PageView'
import DropdownSelect from '../Shared/DropdownSelect'
import Lex from '../Shared/Lex'
// import {withStrategiesApi} from "../../apis/strategies_api"
import CommentThread from './CommentThread/CommentThread'
import PageProvider from '../../modules/PageProvider'

const Strategies = ({ userStore }) => {
  const form = {}
  const { priorityId } = useParams()

  const page = {
    clickUrl: (record) => 'strategy/' + record.id + '/goals',
    formName: () => userStore.lex.strategy,
    recordType: () => 'strategies',
    pageHeader: () => {
      return <div>
        <h4 className="inline-block">
          <div
            className="inline-block hover"
            onClick={() => userStore.appNavigate('priorities')}
          >
            <Lex term={priorityId ? 'priority' : 'priorities'} />:
          </div>
          <DropdownSelect
            className="inline-block"
            selected={userStore.findRecord('priorities', priorityId) || {
              name: 'All',
              id: null
            }}
            options={[{ name: 'All', id: null }].concat((userStore.getRecords('priorities') || []).filter(p => p && p.name))}
            callback={(selected) => userStore.appNavigate(selected.id ? 'priority/' + selected.id + '/strategies' : 'strategies')}
          />
        </h4>
        <i className="fas fa-arrow-right" /> <h3 className="inline-block"><Lex term="strategy" plural /></h3>
      </div>
    },
    newRecord: () => {
      return { name: '', description: '', priorityId }
    },
    records: () => {
      return (userStore.getRecords('strategies') || []).filter(s => s && s.name).sort((a, b) => ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))
    },
    filterRecords: (s) => {
      return !priorityId || priorityId === s.priorityId
    },
    formFields: (record) => {
      record ||= { name: '', description: '', teamId: null, priorityId }

      return <div>
        <Label><Lex term="name" /></Label><Input data-cy="strategy-name-input" innerRef={el => form.name = el} defaultValue={record.name} />
        <br />
        <Label><Lex term="description" /></Label><Input
          data-cy="strategy-description-input"
          innerRef={el => form.description = el}
          defaultValue={record.description}
        /> <br />
        <Label><Lex term="team" /></Label>
        <Input type="select" innerRef={el => form.teamId = el} defaultValue={record.teamId}>
          {(userStore.getRecords('teams') || []).filter(t => t && t.name).map((t, index) => <option
            key={index}
            value={t.id}
          >{t.name}
          </option>)}
        </Input>
        <Label><Lex term="priority" /></Label><Input
          type="select" innerRef={el => form.priorityId = el}
          defaultValue={record.priorityId}
        >
          {(userStore.getRecords('priorities') || []).filter(p => p && p.name).map((p, index) => <option
            key={index}
            value={p.id}
          >{p.name}
          </option>)}
        </Input>
      </div>
    },
    saveRecord: (record) => {
      record.name = form.name.value
      record.description = form.description.value
      record.teamId = form.teamId.value
      record.priorityId = form.priorityId.value
      if (record.id) { userStore.updateStrategy(record) } else { userStore.createStrategy(record.name, record.description, record.teamId, record.priorityId) }
      return true
    },
    destroy: (record) => userStore.destroyStrategy(record),
    showJournal: false,
    showComment: true,
    commentThreadPageProvider: PageProvider({
      formFields: (record) => <CommentThread commentable={record}>{record.name}</CommentThread>,
      record: () => { return {} }
    })
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Strategies)
